<div>
    @if (showLabel) {
        <h4>Parent locations for this {{ team.teamTypeName }}</h4>
    }
    @if (parentTeamLocations.length > 0) {
        <dx-list class="dx-list-boxed"
                 (onItemDeleted)="removeTeamLocation($event)"
                 [dataSource]="parentTeamLocations"
                 [hoverStateEnabled]="false"
                 [focusStateEnabled]="false"
                 [activeStateEnabled]="false"
                 [allowItemDeleting]="true"
                 [disabled]="disabled">
            <div *dxTemplate="let teamLocation of 'item'">
                <ng-container [ngTemplateOutlet]="parentItems"
                              [ngTemplateOutletContext]="{$implicit: teamLocation}"></ng-container>
            </div>
        </dx-list>
    }

    <dx-select-box [dataSource]="parentDataSource"
                   (onValueChanged)="onSelectValueChange($event, true)"
                   [grouped]="true"
                   [searchEnabled]="true"
                   [readOnly]="disabled"
                   searchExpr="name"
                   placeholder="Select location to place this {{team.teamTypeName}} into..."
                   data-test="select-team-location">
            <span *dxTemplate="let area of 'item'">
                <ng-container [ngTemplateOutlet]="parentItems"
                              [ngTemplateOutletContext]="{$implicit: area}"></ng-container>
            </span>
        <div *dxTemplate="let area of 'field'">
            @if (!!area) {
                <ng-container [ngTemplateOutlet]="parentItems"
                              [ngTemplateOutletContext]="{$implicit: area}"></ng-container>
                <dx-text-box class="d-none"
                             value="hidden element required by dxTemplate"
                             [readOnly]="true"></dx-text-box>
            } @else {
                <dx-text-box value=""
                             placeholder="Select location to place this {{team.teamTypeName}} into..."></dx-text-box>

            }
        </div>
    </dx-select-box>
</div>

<ng-template #parentItems
             let-item>
    <div>
        @if (getAsZoneLocation(item); as zone) {
            <adapt-zone-label [zone]="zone"></adapt-zone-label>
        }
        @if (getAsParentTeamLocation(item); as team) {
            <ng-container [ngTemplateOutlet]="teamItem"
                          [ngTemplateOutletContext]="{$implicit: team}"></ng-container>
        }
    </div>
</ng-template>

@if (showChildSelection) {
    <hr>

    <div class="form-group">
        <h4>Children within this {{ team.teamTypeName }}</h4>
        <ng-container *ngTemplateOutlet="childLocationsList; context: {$implicit: activeChildTeamLocations, allowReordering: true}"></ng-container>
        <ng-container *ngTemplateOutlet="childLocationsList; context: {$implicit: inactiveChildTeamLocations, allowReordering: false}"></ng-container>

        <ng-template #childLocationsList
                     let-locations
                     let-allowReordering="allowReordering">
            @if (locations.length > 0) {
                <dx-list [items]="locations"
                         [hoverStateEnabled]="false"
                         [activeStateEnabled]="false"
                         [focusStateEnabled]="false"
                         [allowItemDeleting]="true"
                         (onItemReordered)="reorderItems()"
                         (onItemDeleted)="onItemDeleted($event)"
                         [disabled]="disabled"
                         height="auto"
                         [attr.data-test]="allowReordering ? 'reorder-locations-list' : 'inactive-locations-list'">
                    <dxo-item-dragging [allowReordering]="allowReordering"></dxo-item-dragging>
                    <div *dxTemplate="let teamLocation of 'item'">
                        @if (getAsChildTeamLocation(teamLocation); as team) {
                            <ng-container [ngTemplateOutlet]="teamItem"
                                          [ngTemplateOutletContext]="{$implicit: team}"></ng-container>
                        }
                    </div>
                </dx-list>
            }
        </ng-template>

        <dx-select-box [dataSource]="childDataSource"
                       (onValueChanged)="onSelectValueChange($event, false)"
                       [grouped]="true"
                       [searchEnabled]="true"
                       searchExpr="name"
                       [readOnly]="disabled"
                       placeholder="Select child to place into this {{team.teamTypeName}}..."
                       data-test="select-child-team-location">
            <span *dxTemplate="let area of 'item'">
                <ng-container [ngTemplateOutlet]="childItem"
                              [ngTemplateOutletContext]="{$implicit: area}"></ng-container>
            </span>
            <div *dxTemplate="let area of 'field'">
                @if (!!area) {
                    <ng-container [ngTemplateOutlet]="childItem"
                                  [ngTemplateOutletContext]="{$implicit: area}"></ng-container>
                    <dx-text-box class="d-none"
                                 value="hidden element required by dxTemplate"
                                 [readOnly]="true"></dx-text-box>
                } @else {
                    <dx-text-box value=""
                                 placeholder="Select child to place into this {{team.teamTypeName}}..."></dx-text-box>
                }
            </div>
        </dx-select-box>
    </div>

    <ng-template #childItem
                 let-item>
        <div>
            @if (getAsChildTeamLocation(item); as team) {
                <ng-container [ngTemplateOutlet]="teamItem"
                              [ngTemplateOutletContext]="{$implicit: team}"></ng-container>
            }
        </div>
    </ng-template>
}

<ng-template #teamItem
             let-team>
    <div class="d-flex align-items-center gap-1"
         [class.opacity-75]="!team.isActive()">
        <adapt-link-team [team]="team"
                         [showIcon]="true"
                         [adaptLinkDisabled]="true"></adapt-link-team>
        <adapt-team-inactive-badge [team]="team"></adapt-team-inactive-badge>
    </div>
</ng-template>
